<template>
  <div class="ui fluid container fc-product-container">
    <div class="fc-banner" v-if="category != null && category != undefined" :style="{backgroundColor: category.BgColor}">
      <div class="ui container">
        <div>
          <div class="fc-crumbs">
            <router-link :to="`${this.RouterConfig.Home}`">Home</router-link>
            &gt;
            <span>{{ category.Name }}</span>
          </div>
          <div class="fc-title">
            {{ category.Name }}
          </div>
          <div class="fc-desc">
            {{ category.Descriptions }}
          </div>
        </div>
        <div>
          <img :src="category.PhotoKey" />
        </div>
      </div>
    </div>
    <div class="ui container">
      <component :is="component" :category="category" v-if="component" />
    </div>
  </div>
</template>
<script>
export default {
  asyncData ({ store, route }) {
    const asyncStatus = store.dispatch('product/getProductList', route)
    return asyncStatus
  },
  name: 'dynamic-product-list',
  props: [
    'category'
  ],
  data () {
    return {
      component: null
    }
  },
  // created () {
  //   this.$store.dispatch('product/getProductList', this.category)
  // },
  created () {
    if (!this.category) {
      // this.component = () => import('../../views/Dashboard.vue')
    } else {
      if (this.category.Template === 'Standard') {
        this.component = () => import('./Standard.vue')
      } else if (this.category.Template === 'AlaCarte') {
        this.component = () => import('./AlaCarte.vue')
      } else if (this.category.Template === 'Combo') {
        this.component = () => import('./Combo.vue')
      }
    }
  },
  watch: {
    category () {
      if (!this.category) {
        this.component = () => import('../../views/Dashboard.vue')
      } else {
        if (this.category.Template === 'Standard') {
          this.component = () => import('./Standard.vue')
        } else if (this.category.Template === 'AlaCarte') {
          this.component = () => import('./AlaCarte.vue')
        } else if (this.category.Template === 'Combo') {
          this.component = () => import('./Combo.vue')
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/product/Index.vue